import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const submitInquiry = createAsyncThunk(
  "inquiries/submitInquiry",
  async (inquiryData) => {
    const { data } = await api.post("/inquiries", inquiryData);
    return data;
  },
);

const inquiriesSlice = createSlice({
  name: "inquiries",
  initialState: {
    submitting: false,
    success: false,
    error: null,
  },
  reducers: {
    resetInquiryState: (state) => {
      state.submitting = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitInquiry.pending, (state) => {
        state.submitting = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitInquiry.fulfilled, (state) => {
        state.submitting = false;
        state.success = true;
      })
      .addCase(submitInquiry.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.error.message;
      });
  },
});

export const { resetInquiryState } = inquiriesSlice.actions;
export default inquiriesSlice.reducer;
